module.exports = __webpack_public_path__ + "img/zona_camastros.43dd3491.jpg";